//---- VUE IMPORTS ----
import { Chart } from "chart.js";
import Vue from "vue";
import DrawflowActorItem from "./vue/backend/drawflow_actor_item.vue";
import DrawflowActorPropertyItem from "./vue/backend/drawflow_actor_property_item.vue";
import DrawflowArticleMeasureItem from "./vue/backend/drawflow_actor_property_item.vue";
import DrawflowMeasureItem from "./vue/backend/drawflow_measure_item.vue";
import DrawflowMeasureWithOptionsItem from "./vue/backend/drawflow_measure_with_options_item.vue";
// Drawflow
import DrawflowPropertyItem from "./vue/backend/drawflow_property_item.vue";
import DrawflowTopRightTags from "./vue/backend/drawflow_top_right_tags.vue";
import GameCloneWorkerItem from "./vue/backend/game_clone_worker_item.vue";
import ActorListItems from "./vue/global_components/actor_list_items.vue";
import ApprovalRatingsComponent from "./vue/global_components/approval_ratings.vue";
import AnalysisIndicatorLineChart from "./vue/global_components/graphs_and_visualizations/analysis_indicator_line_chart.vue";
import ColoredTrendArrow from "./vue/global_components/graphs_and_visualizations/colored_trend_arrow.vue";
import DonutChart from "./vue/global_components/graphs_and_visualizations/donut_chart.vue";
import HorizontalBarChart from "./vue/global_components/graphs_and_visualizations/horizontal_bar_chart.vue";
import LineChart from "./vue/global_components/graphs_and_visualizations/line_chart.vue";
import PercentFromCenterBar from "./vue/global_components/graphs_and_visualizations/percent_from_center_bar.vue";
import RadarChart from "./vue/global_components/graphs_and_visualizations/radar_chart.vue";
import RainbowRangeValueBox from "./vue/global_components/graphs_and_visualizations/rainbow_range_value_box.vue";
import SankeyChart from "./vue/global_components/graphs_and_visualizations/sankey_chart.vue";
import WorldMap from "./vue/global_components/graphs_and_visualizations/world_map.vue";
import GroupApprovalRatingsComponent from "./vue/global_components/group_approval_ratings.vue";
import ModeratorChatActorComponent from "./vue/global_components/moderator_chat-actor.vue";
import ModeratorChatModeratorComponent from "./vue/global_components/moderator_chat-moderator.vue";
import NumberComparisonTtag from "./vue/global_components/number_comparison_tag.vue";
import AnswerOptionAnswerAttemptsCount from "./vue/quizzes_components/answer_option_answer_attempts_count.vue";
import AnswerOptionHorizontalBar from "./vue/quizzes_components/answer_option_horizontal_bar.vue";
import QuestionTotals from "./vue/quizzes_components/question_totals.vue";
import initVueStore from "./vue/stores/vue_store";
import {
	debounceAdminFetchActorsVueData,
	emitJsonForVue,
	lazyLoadPageVueInstances,
	mountElementsInContainer,
	setUpVueInstances,
} from "./vue/utils";
import VueHooks from "./vue/vue_hooks.js";

import "./vue/click_outside_directive.js";

import DraftRatingsDonut from "./vue/drafts_components/draft_ratings_donut.vue";
import MeasureEffectsRow from "./vue/measures_components/measure_effects_row.vue";
import MeasuresContainer from "./vue/measures_components/measures_container.vue";
import ActorMeasures from "./vue/properties_components/actor_measures.vue";
import ActorProperties from "./vue/properties_components/actor_properties.vue";
import ActorPropertiesDonut from "./vue/properties_components/actor_properties_donut.vue";
import ActorPropertyBarAbsolute from "./vue/properties_components/actor_property_bar_absolute.vue";
import ActorPropertyBarRelative from "./vue/properties_components/actor_property_bar_relative.vue";
import ActorPropertyStandalone from "./vue/properties_components/actor_property_standalone.vue";
import ActorPropertiesGoals from "./vue/unlockables_components/actor_properties_goals.vue";

//---- VUE ASSIGNMENTS ----
pp.vue = {
	lazyLoadPageVueInstances: lazyLoadPageVueInstances,
	mountElementsInContainer: mountElementsInContainer,
	emitJsonForVue: emitJsonForVue,
	debounceAdminFetchActorsVueData: debounceAdminFetchActorsVueData,
	bus: new Vue({}),
};

setUpVueInstances();

Vue.component("approval-ratings", ApprovalRatingsComponent);
Vue.component("group-approval-ratings", GroupApprovalRatingsComponent);
Vue.component("moderator-chat-moderator", ModeratorChatModeratorComponent);
Vue.component("moderator-chat-actor", ModeratorChatActorComponent);

Vue.component("actor-list-items", ActorListItems);
Vue.component("number-comparison-tag", NumberComparisonTtag);

Vue.component("answer-option-horizontal-bar", AnswerOptionHorizontalBar);
Vue.component(
	"answer-option-answer-attempts-count",
	AnswerOptionAnswerAttemptsCount,
);
Vue.component("question-totals", QuestionTotals);

// I can't think of a better way than just having a bunch of global component defs
Vue.component("percent-from-center-bar", PercentFromCenterBar);
Vue.component("colored-trend-arrow", ColoredTrendArrow);
Vue.component("rainbow-range-value-box", RainbowRangeValueBox);

Vue.component("analysis-indicator-line-chart", AnalysisIndicatorLineChart);
Vue.component("radar-chart", RadarChart);
Vue.component("sankey-chart", SankeyChart);
Vue.component("world-map", WorldMap);
Vue.component("donut-chart", DonutChart);
Vue.component("line-chart", LineChart);
Vue.component("horizontal-bar-chart", HorizontalBarChart);

Vue.component("actor-properties", ActorProperties);
Vue.component("actor-properties-donut", ActorPropertiesDonut);
Vue.component("draft-ratings-donut", DraftRatingsDonut);
Vue.component("actor-property-bar-absolute", ActorPropertyBarAbsolute);
Vue.component("actor-property-bar-relative", ActorPropertyBarRelative);
Vue.component("actor-property-standalone", ActorPropertyStandalone);
Vue.component("actor-properties-goals", ActorPropertiesGoals);
Vue.component("actor-measures", ActorMeasures);
Vue.component("measures-container", MeasuresContainer);
Vue.component("measure-effects-row", MeasureEffectsRow);

// VUE BACKEND
Vue.component("game-clone-worker-item", GameCloneWorkerItem);
Vue.component("drawflow-property-item", DrawflowPropertyItem);
Vue.component("drawflow-actor-property-item", DrawflowActorPropertyItem);
Vue.component("drawflow-measure-item", DrawflowMeasureItem);
Vue.component(
	"drawflow-measure-with-options-item",
	DrawflowMeasureWithOptionsItem,
);
Vue.component("drawflow-article-measure-item", DrawflowArticleMeasureItem);
Vue.component("drawflow-actor-item", DrawflowActorItem);
Vue.component("drawflow-top-right-tags", DrawflowTopRightTags);

//---- VANILLA ASSIGNMENTS ----
pp.vueHooks = VueHooks;
pp.initVueStore = initVueStore;

Chart.defaults.font.family = "proxima-nova";
Chart.defaults.color = "#7c8dac";
